import FurtherResources from "./FurtherResources"

export default FurtherResources
